import Warehouse from 'renderer/Global/Attributes/Facilities/Warehouse/Warehouse';
import inventory from 'renderer/Global/Attributes/Inventory/inventory';
import inventoryItem from 'renderer/Global/Attributes/Inventory/inventoryItem';
import { allItems } from 'renderer/Global/Attributes/Item/AllItems';
import State from '../State';
import { currentVersion } from './currentVersion';
import { getItem } from './localStorage/localStorage';
import Probe from 'renderer/Global/Attributes/Facilities/Probes/Probe';
import Upgrades from 'renderer/Global/Attributes/Facilities/Upgrades/Upgrades';
import Transaction from 'renderer/Global/Attributes/History/Transaction/Transaction';

export default function loadGlobalData() {
  let defaultGlobalSettings: State = {
    version: currentVersion,
    money: 0,
    pets: [],
    compendium: new Map<number, boolean>(),
    compendiumArr: [],
    inventory: new inventory([
      // new inventoryItem(allItems[3], 100),
      // new inventoryItem(allItems[1], 40),
      // new inventoryItem(allItems[2], 65),
    ]),
    transactionHistory: [],
    totalMoneyEarned: 0,
    totalItemsSold: 0,
    totalTransportationCostsPaid: 0,
    storage: new Warehouse(true, 0, 'Storage', [
      // new Probe(
      //   5,
      //   allItems[3],
      //   'Ocean (Lesh)',
      //   new Upgrades('M', 'Liquid', 'Thin', 'Black')
      // ),
    ]),
    warehouses: [
      // new Warehouse(false, 100, 'firstOne', [
      //   new Probe(
      //     100,
      //     allItems[2],
      //     'Ocean (Lesh)',
      //     new Upgrades('S', 'Liquid', 'Thin', 'Black')
      //   ),
      //   new Probe(
      //     150,
      //     allItems[1],
      //     'Ocean (Lesh)',
      //     new Upgrades('L', 'Liquid', 'Thin', 'Black')
      //   ),
      // ]),
      // new Warehouse(false, 150, 'two twenty', [
      //   new Probe(
      //     100,
      //     allItems[1],
      //     'Ocean (Lesh)',
      //     new Upgrades('L', 'Liquid', 'Thin', 'Black')
      //   ),
      //   new Probe(
      //     50,
      //     allItems[2],
      //     'Ocean (Lesh)',
      //     new Upgrades('L', 'Liquid', 'Thin', 'Black')
      //   ),
      // ]),
    ],
  };

  let existingSaveData = getItem<State>('spectreSaveData');
  if (existingSaveData != null) {
    // Rebuild classes manually since methods are stripped by JSON.stringify

    defaultGlobalSettings.version = existingSaveData.version;
    defaultGlobalSettings.money = existingSaveData.money;
    // Skip pets
    defaultGlobalSettings.compendiumArr = existingSaveData.compendiumArr;

    for (let i = 0; i < defaultGlobalSettings.compendiumArr.length; i++) {
      const existingID = defaultGlobalSettings.compendiumArr[i];
      defaultGlobalSettings.compendium.set(existingID, true);
    }

    defaultGlobalSettings.totalMoneyEarned = existingSaveData.totalMoneyEarned;
    defaultGlobalSettings.totalItemsSold = existingSaveData.totalItemsSold;
    defaultGlobalSettings.totalTransportationCostsPaid =
      existingSaveData.totalTransportationCostsPaid;

    let newInv: inventory = new inventory([]);
    let localInvItems = existingSaveData.inventory.inventoryItems;

    for (let i = 0; i < localInvItems.length; i++) {
      newInv.addInventoryItem(
        new inventoryItem(
          allItems[localInvItems[i].item.id],
          localInvItems[i].amount
        )
      );
    }

    defaultGlobalSettings.inventory = newInv;

    for (let i = 0; i < existingSaveData.transactionHistory.length; i++) {
      let curr = existingSaveData.transactionHistory[i];

      let newTransaction = new Transaction(
        allItems[curr.item.id],
        curr.isBuy,
        curr.buyPrice,
        curr.sellPrice,
        curr.transportationCost,
        curr.quantity,
        curr.feesPaid,
        curr.marketplaceName,
        curr.total
      );

      defaultGlobalSettings.transactionHistory.push(newTransaction);
    }

    let newStorage: Warehouse = new Warehouse(true, 0, 'storage', []);

    for (let i = 0; i < existingSaveData.storage.probes.length; i++) {
      const currProbe = existingSaveData.storage.probes[i];

      newStorage.probes.push(
        new Probe(
          currProbe.amount,
          currProbe.targetItem,
          currProbe.targetLocation,
          currProbe.upgrades
        )
      );
    }

    defaultGlobalSettings.storage = newStorage;

    for (let i = 0; i < existingSaveData.warehouses.length; i++) {
      const currWarehouse = existingSaveData.warehouses[i];
      let newWarehouse = new Warehouse(
        false,
        currWarehouse.capacity,
        currWarehouse.nickname,
        []
      );

      for (let k = 0; k < currWarehouse.probes.length; k++) {
        const currProbe = currWarehouse.probes[k];

        newWarehouse.probes.push(
          new Probe(
            currProbe.amount,
            currProbe.targetItem,
            currProbe.targetLocation,
            currProbe.upgrades
          )
        );
      }

      defaultGlobalSettings.warehouses.push(newWarehouse);
    }
  }

  return defaultGlobalSettings;
}
